const t = {
  name: "Clipboard",
  dimensions: { width: 28, height: 41 },
  content: `
    <svg>
    <g clip-path="url(#clip0_12_3886)">
    <path d="M2 37.0025V7.00253H6V10.0025C6 10.5525 6.45 11.0025 7 11.0025H21C21.55 11.0025 22 10.5525 22 10.0025V7.00253H25C25.55 7.00253 26 7.45253 26 8.00253V38.0025H3C2.45 38.0025 2 37.5525 2 37.0025ZM20 7.00253V9.00253H8V7.00253H20ZM12 4.00253C12 2.79253 13.09 1.82253 14.34 2.03253C15.32 2.19253 16 3.12253 16 4.11253V5.00253H12V4.00253ZM26 5.00253H22H18V4.18253C18 2.09253 16.48 0.222526 14.4 0.0225264C12.02 -0.207474 10 1.66253 10 4.00253V5.00253H6H2C0.9 5.00253 0 5.90253 0 7.00253V38.0025C0 39.1025 0.9 40.0025 2 40.0025H26C27.1 40.0025 28 39.1025 28 38.0025V7.00253C28 5.90253 27.1 5.00253 26 5.00253Z" />
    </g>
    <defs>
    <clipPath id="clip0_12_3886">
    <rect width="28" height="39.9992" fill="currentColor" transform="translate(0 0.00335693)"/>
    </clipPath>
    </defs>
    </svg>

  `
};
export {
  t as Clipboard
};
